// extracted by mini-css-extract-plugin
export default {"links":"Header_links__+kd8K","title":"Header_title__l+wMf"};